
module.controller('TagRefreshEmitter', function($scope, $timeout) {
    var lastParams;

    this.refresh = $scope.refresh = function(params) {
        $timeout(function() {
            lastParams = params;
            $scope.$broadcast('tagRefresh', params);
        });
    };

    $scope.triggerRefresh = function() {
        // Don't actually refresh until refresh has been called once;
        // This prevents double requests on initial page load.
        if (angular.isDefined(lastParams)) {
            $scope.refresh(lastParams);
        }
    };

    $scope.$on('requestTagParams', $scope.triggerRefresh);
});

module.service('TagRefreshService', function($timeout) {

    function bindTagRefreshToScope($scope, refreshEvent, requestParamsEvent) {
        var lastTags;

        refreshEvent = refreshEvent || 'tagRefresh';
        requestParamsEvent = requestParamsEvent || 'requestTagParams';

        function refresh(tags) {
            $timeout(function() {
                lastTags = tags;
                $scope.$broadcast(refreshEvent, tags);
            });
        }

        function triggerRefresh() {
            if (angular.isDefined(lastTags)) {
                refresh(lastTags);
            }
        }

        $scope.$on(requestParamsEvent, triggerRefresh);
        $scope.refresh = refresh;
        $scope.triggerRefresh = triggerRefresh;

        return refresh;
    }

    function bindAddRemoveEvents($scope, tagFilterController) {
        $scope.$on('addTag', function(event, tag) {
            tagFilterController.addRawTag(tag);
        });

        $scope.$on('removeTag', function(event, tag) {
            tagFilterController.removeTag(tag);
        });
    }

    return {
        bindTagRefreshToScope: bindTagRefreshToScope,
        bindAddRemoveEvents: bindAddRemoveEvents,
    }

});


module.controller('TagReportController', function($scope, report) {
    this.report = $scope.report = report;
    ($scope.triggerRefresh || angular.noop)();
    $scope.$on('tagRefresh', function(event, params) {
        report.update(params);
    });
});
